import { createFileRoute, type ErrorComponentProps } from "@tanstack/react-router";
import { CmsRouteView } from "@/components/cms/CmsRouteView";
import { publishedCmsPageQuery } from "@/lib/cms/queries";
import { canonicalUrl } from "@/lib/seo/site";

export const Route = createFileRoute("/privacy")({
  head: () => ({ meta: [
    { title: "Privacy Policy — CB16 Atelier" },
    { name: "description", content: "How CB16 collects, uses and safeguards your personal information." },
    { property: "og:title", content: "CB16 Privacy Policy" },
    { property: "og:description", content: "How CB16 collects, uses and safeguards your personal information." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { property: "og:url", content: canonicalUrl("/privacy") },
  ], links: [{ rel: "canonical", href: canonicalUrl("/privacy") }] }),
  loader: ({ context }) => context.queryClient.ensureQueryData(publishedCmsPageQuery("privacy")),
  errorComponent: ({ error }: ErrorComponentProps) => (
    <div role="alert" className="mx-auto max-w-3xl px-6 py-24 text-center text-sm text-black/60">
      {error instanceof Error ? error.message : "Something went wrong."}
    </div>
  ),
  notFoundComponent: () => (
    <div className="mx-auto max-w-3xl px-6 py-24 text-center text-sm text-black/60">Page not found.</div>
  ),
  component: () => <CmsRouteView slug="privacy" fallbackTitle="Privacy Policy" />,
});